import { bffRetailMedia } from '~/middlewares/axios'

export const getInvestmentReferenceServiceKey = 'getInvestmentReference'

export const getInvestmentReferenceService = (params: {
  channel: CampaignChannelValue
  objective: InvestmentObjectiveType
}) =>
  bffRetailMedia.get<InvestmentReference>(
    '/configuration/offsite/investment-reference',
    { params }
  )
